module.exports = __webpack_public_path__ + "assets/img/title.6f4b0d37.png";